import React from 'react';
import { Link } from 'react-router-dom';

const CardsContainer = () => {
    const cardsData = [
        {
          title: "Training for Colleges",
          content: (
            <>
              PilotHelper strengthens peer support programs at colleges 
              and universities with flight programs by providing aviation-specific peer support training 
              for college pilots. Instead of relying only on designated mentors, PilotHelper trains all 
              college pilots to recognize when a classmate may need support and respond effectively, 
              allowing support to happen naturally among friends and classmates they trust. Click 
              "Learn More" to see how PilotHelper complements and strengthens existing college peer 
              support programs.
            </>
          ),
          icon: "fas fa-graduation-cap",
          link: "/training-for-colleges"
        },
        {
          title: "Training for Airlines",
          content: (
            <>
              PilotHelper enhances existing airline peer support programs by training all pilots, as well as their trusted friends and family members, in peer support. This approach strengthens safety culture, improves crew communication, and encourages early intervention before challenges impact operations. Click "Learn More" to see how PilotHelper complements and strengthens existing airline peer support programs.
            </>
          ),
          icon: "fas fa-plane",
          link: "/training-for-airlines"
        },
        {
          title: "Training for Flight Schools",
          content: (
            <>
              PilotHelper provides aviation-specific peer support training for flight schools, equipping flight instructors with the skills to recognize when a student pilot may be struggling and provide effective peer support. By strengthening the instructor–student relationship, PilotHelper helps flight schools reinforce safety culture, improve communication, and support student retention throughout training. Click "Learn More" to see why flight schools should implement PilotHelper's peer support training.
            </>
          ),
          icon: "fas fa-chalkboard-teacher",
          link: "/training-for-flight-schools"
        }
      ];
      

    return (
        <div className='container my-5'>
            <div className='row'>
                {cardsData.map((card, index) => (
                    <div key={index} className='col-md-4 mb-4'>
                        <div className='card h-100' style={{backgroundColor: 'var(--dark-blue)', color: 'white'}}>
                            <div className='card-body position-relative d-flex flex-column'>
                                {/* Icon in the top-left corner */}
                                <div className='position-absolute top-0 start-0 p-3'>
                                    <i className={`${card.icon} fa-2x`} aria-hidden="true"></i>
                                </div>
                                <h3 className='card-title mt-5'>{card.title}</h3>
                                <p className='card-text flex-grow-1'>{card.content}</p>
                                <Link
                                    to={card.link}
                                    className='btn btn-light mt-3'
                                    style={{
                                        backgroundColor: 'white',
                                        color: 'var(--dark-blue)',
                                        fontWeight: 'bold',
                                        alignSelf: 'flex-start'
                                    }}
                                >
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CardsContainer;